






















































import { Component, Vue, Watch } from "vue-property-decorator";
import { getImgUrl, allLessons, leaderData } from "../../utils/dummy";
import CourseListCard from "../../components/CourseListCard.vue";
import FilterBox from "../../components/FilterBox.vue";
import Button from "../../components/Button.vue";
import Dropdown from "../../components/fields/Dropdown.vue";
import { Getter, Action } from "vuex-class";
import {
  ACCESS_LEVEL,
  COURSES,
  COURSE_CREATORS
} from "../../store/getters.names";
import { namespaced, NS_ADMIN } from "../../store/namespace";
import { FlatCourse, FlatUser, FlatProfile } from "../../store/store.types";
import { FETCH_COURSES, FETCH_ADMIN_DATA } from "../../store/actions.names";
import debounce from "debounce";
@Component({
  name: "CourseOverview",
  components: {
    CourseListCard,
    Button,
    FilterBox,
    Dropdown
  }
})
export default class CourseOverView extends Vue {
  @Getter(ACCESS_LEVEL) accessLevel: number | null;
  @Getter(namespaced(NS_ADMIN, COURSE_CREATORS)) courseCreators!: any;
  @Getter(namespaced(NS_ADMIN, COURSES)) courses: FlatCourse[];
  @Action(namespaced(NS_ADMIN, FETCH_COURSES)) fetchCourses: any;
  @Action(namespaced(NS_ADMIN, FETCH_ADMIN_DATA)) fetchAdminData: any;
  public showBox: boolean = false;

  filters = {
    creator: null
  };
  toggleBox() {
    this.showBox = !this.showBox;
  }

  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.fetchCourses();
      vm.fetchAdminData();
    });
  }

  beforeRouteUpdate(to, from, next) {
    this.fetchCourses();
    this.fetchAdminData();
    next();
  }

  get instructors(): any {
    if (!this.courseCreators || !this.courseCreators.results) {
      return [];
    }
    const data = this.courseCreators.results.map(val => {
      return {
        value: val.user.id,
        label: val.user.full_name
      };
    });
    return [{ value: null, label: "All Instructors" }, ...data];
  }

  @Watch("filters", { deep: true })
  handleFilterChanges(val: any, oldVal: any) {
    const notNulls = {};
    Object.keys(val).map(key => {
      const v = val[key];
      if (v != null) {
        notNulls[key] = val[key];
      }
    });
    // console.log(notNulls);
    this.fetchCourses({ params: notNulls, fresh: true });
  }

  search = debounce(e => {
    this.fetchCourses({ params: { search: e.target.value }, fresh: true });
  }, 300);

 
}
